import React, { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { PageHeader } from '../../components';
import { agencyService } from '../../services/agencyService';
import { CARD, Field, errorMessage } from './shared';

/**
 * Agency > Account (from the name in the top bar). The agency's permanent id,
 * which is also the administrator's login, and the registered details. Only
 * the ServPatch administrator changes these; a forgotten PIN is reset from
 * the sign-in page, to the registered email only.
 */
const AgencyAccount = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    agencyService.account()
      .then((res) => setData(res.data))
      .catch((err) => toast.error(errorMessage(err, 'Could not load your account.')));
  }, []);

  const agency = data?.agency;
  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="Agency account" subtitle="Your agency's ServPatch details." />
      <div className={`${CARD} p-6 grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-3xl`}>
        <Field label="Agency name">{agency?.name}</Field>
        <Field label="Agency ID (your login)">{agency?.org_id}</Field>
        <Field label="Email">{agency?.email}</Field>
        <Field label="Phone">{agency?.phone}</Field>
        <div className="sm:col-span-2"><Field label="Address">{agency?.address}</Field></div>
        <Field label="Administrator">{data?.admin?.name}</Field>
        <Field label="Registered email">{data?.admin?.email}</Field>
        <Field label="Connected care homes">{data?.connected_homes}</Field>
        <Field label="Active staff">{data?.active_staff}</Field>
      </div>
      <div className={`${CARD} p-5 max-w-3xl text-[13px] text-[#475569] dark:text-gray-300`}>
        Forgot your PIN? Use <strong>Forgot PIN</strong> on the sign-in page — the reset link goes to the registered
        email above. To change the agency name, email or administrator, contact ServPatch support.
      </div>
    </div>
  );
};

export default AgencyAccount;
